import React, { Component } from 'react';
import './basicforms.css';

class SignInForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleForgot = this.handleForgot.bind(this);
  }

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value});
  }

  handleForgot(event) {

    this.props.auth.forgotPassword(this.state.email).then(() => {
      console.log('Forgot password code sent!');
      alert('Code resent successfully to ' + this.state.email + '!');
      this.props.history.push('/forgotpassword/' + this.state.email);
    }).catch(error => {
      console.log(error);
      alert(error.message || JSON.stringify(error));
    });

  }

  handleSubmit(event) {
    this.props.auth.signIn({
      username: this.state.email,
      password: this.state.password//,
      //validationData: []
    })
      .then(authUser => {
        console.log(authUser);
        this.props.handleSignIn();
        //console.log(authUser.user.email);
        //this.setState({
          //email: '',
          //password: ''
        //});
      })
      .catch(error => {
        console.log(error);
        alert(error.message || JSON.stringify(error));
        if (error.code === "UserNotConfirmedException") {
          this.props.history.push('/emailconfirm/' + this.state.email);
        }
    });
    event.preventDefault();
  }

  render() {

    return (

		<form className='basicforms' onSubmit={this.handleSubmit}>
			<div className='form_container' >
				<p className='pagetitle'>{this.props.name}</p>
				<div className="row">
					<div className="col-25">
						<label>email</label>
					</div>
					<div className="col-50">
						<input type="email" name="email" value={this.state.email} onChange={this.handleChange} />
					</div>
				</div>
				<div className="row">
					<div className="col-25">
						<label>Password</label>
					</div>
					<div className="col-50">
						<input type="password" name="password" value={this.state.password} onChange={this.handleChange} />
					</div>
				</div>
				<div className="row">
				<div className="col-75">
					<input type="submit" value="Submit"/>
				</div>
		    	</div>

          <div className="row">
            <div className="col-75">
              <input type="button" value="Forgot Password" onClick={this.handleForgot}/>
            </div>
          </div>

			</div>
		  </form>

    );
  }
}

export default SignInForm;



// WEBPACK FOOTER //
// ./src/components/SignInForm.js